import { SystemBaseApi } from "./SystemBaseApi";
import { Methods } from '@newview/infrastructure';

/**
 * Api
 */
export class ProjectdatashareApi extends SystemBaseApi {
    public get ControllerName(): any {
        return 'projectdatashare'
    }
    /**
     * 查询被选中的集合反选
     * @param projectDataId 
     * @returns 
     */
   public getCheckProjectData(projectDataId){
        return this.send({projectDataId:projectDataId},"getCheckProjectData",Methods.GET)
   }


}